import aiAxios from './providers/aiAxios';

/**
 * AI Agent dış servis entegrasyonu (https://ai.ibilityapp.com).
 *
 * Şirketin aktif AI agent sayısını öğrenmek için kullanılır.
 * aiAxios provider'ı zaten Bearer token interceptor'ıyla çalışıyor
 * (localStorage authToken/clientToken kullanır).
 *
 * Backend'in PackageLimitService'i AI agent için hâlâ şirket counter'ını kullanır
 * (webhook üzerinden artıyor/azalıyor). Bu fonksiyon sadece /billing sayfasındaki
 * gerçek zamanlı görüntüleme için çağrılır.
 */

const aiAgentService = {
    /**
     * Şirketin aktif AI agent sayısını döndürür.
     * @param {string} companyId - Şirket UUID'si
     * @returns {Promise<number>} Aktif agent sayısı (hata durumunda 0)
     */
    async getAgentCount(companyId) {
        if (!companyId) return 0;

        try {
            const response = await aiAxios.get('/v2/agents/count', {
                params: { companyId },
            });

            // Beklenen response: { success: true, companyId: "...", agentCount: 42 }
            if (response.data?.success && typeof response.data.agentCount === 'number') {
                return response.data.agentCount;
            }

            return 0;
        } catch (error) {
            // Sessizce başarısız ol — UI bozulmasın, backend usage fallback olur
            console.warn('AiAgentService: count alınamadı', error?.message || error);
            return 0;
        }
    },
};

export default aiAgentService;
